import React from 'react'
import ReactDOM from 'react-dom'
import Link from 'gatsby-link'
import styled from 'styled-components'

import config from '../config'
import { device } from '../media'

import FadeIn from './FadeIn'
import NavLink from './NavLink'
import MailToLink from './MailToLink'
import Navbar from './Navbar'

import logo from '../assets/first-principle-logo.png'

const MobileHeaderContainer = styled.div`
  @media ${device.mobile} {
    display: none;
  }
`

const Header = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: none;
  z-index: 4000;
  display: ${props => props.show ? 'block' : 'none'}
`

const Nav = styled.div`
  line-height: 1;
  position: fixed;
  top: ${props => props.height};
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: ${config.whiteColor}
  padding: ${config.padding};
  overflow: scroll;
`

const HGroup = styled.hgroup`
  line-height: 1;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  background-color: ${config.whiteColor}
  padding: ${config.padding};
  margin: 0;
  z-index: 6000;
`

const Logo = styled.img`
  width: 3.364575823rem;
  margin: 0;
`

const NavToggle = styled.div`
  font-size: 0.384522951rem; // 16 px
  position: absolute;
  top: 50%;
  right: ${config.padding};
  height: ${config.navToggleFontSize + 'px'};
  margin-top: ${'-' + config.navToggleFontSize / 2 + 'px'};;
  cursor: pointer;
`

const SingleLinkContainer = styled.div`
  margin-top: ${config.padding};
  text-align: center;
`

class MobileHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      navVisible: false,
      toggleText: 'Menu',
      hGroupHeight: 0
    };
  }

  toggleNav = () => {
    // const header = ReactDOM.findDOMNode(this.refs.header)
    if ( this.state.navVisible ) {
      this.setState({ 
        navVisible: false,
        toggleText: 'Menu'
      })
      document.documentElement.style.overflow = ''
      // header.style.display = 'none'
    } else { 
      this.setState({ 
        navVisible: true,
        toggleText: 'Close'
      })
      document.documentElement.style.overflow = 'hidden'
      // header.style.display = 'block'
    }
  }

  logoClickHandler = () => {
    if ( this.state.navVisible ) { 
      this.toggleNav() 
    } else {
      return false
    }
  }

  componentDidMount = () => {
    const navToggle = ReactDOM.findDOMNode(this.refs.navToggle)
    const nav = ReactDOM.findDOMNode(this.refs.nav)
    const navLinks = nav.getElementsByTagName('a')
    const hGroup = ReactDOM.findDOMNode(this.refs.hGroup)

    navToggle.addEventListener('click', this.toggleNav)
    for (let i = 0; i < navLinks.length - 1; i++) {
      navLinks[i].addEventListener('click', this.toggleNav)
    }
    this.setState({ hGroupHeight: hGroup.getBoundingClientRect().height })
  }

  render() {
    return (
      <MobileHeaderContainer>
        <HGroup ref='hGroup'>
          <FadeIn>
            <Link onClick={this.logoClickHandler} to='/'><Logo src={logo} alt='First Principle logo' /></Link>
            <NavToggle ref='navToggle'>{this.state.toggleText}</NavToggle>
          </FadeIn>
        </HGroup>
        <Header ref='header' show={this.state.navVisible}>
          <FadeIn>
            <Nav ref='nav'>
              <Navbar mobileDisplay='block' height={this.state.hGroupHeight + 'px'} />
              {/* <SingleLinkContainer><NavLink to="/who-we-are">Who We Are</NavLink></SingleLinkContainer> */}
              <SingleLinkContainer><MailToLink /></SingleLinkContainer>
            </Nav>
          </FadeIn>
        </Header>
      </MobileHeaderContainer>
    )
  }
}

export default MobileHeader



// WEBPACK FOOTER //
// ./src/components/MobileHeader.js